import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "clientProfile" */ './index'),
  loading: () => null,
});
